export const ModuleContext = 'context';
export const ModuleOption = 'option';
export const ModuleEmployee = 'employee';
export const ModuleEmployeeType = 'employeeType';
export const ModuleFixedAsset = 'fixedAsset';
export const ModulePayrollItem = 'payrollItem';
export const ModuleLayout = 'layout';
export const ModuleOrganizationUnit = 'organizationUnit';
export const ModuleAsset = 'asset';
export const ModuleInventoryItem = 'inventoryItem';
export const ModuleToolList = 'toolList';
export const ModuleAccount = 'account';
export const ModuleAccountCategory = 'accountCategory';
export const ModuleBuPlanWithDraw = 'buPlanWithDraw';
export const ModuleBUTransfer = 'bUTransfer';
export const ModuleAccountingObject = 'accountingObject';
export const ModuleAccountingObjectCache = 'accountingObjectCache';
export const ModuleDepartment = 'department';
export const ModuleCurrency = 'currency';
export const ModuleBaWithdraw = 'baWithdraw';
export const ModuleInventoryCategory = 'inventoryCategory';
export const ModuleStock = 'stock';
export const ModuleBuPlanReceipt = 'buPlanReceipt';
export const ModuleBudgetChapter = 'budgetChapter';
export const ModuleStatistic = 'statistic';
export const ModuleTypeOfFundObject = 'typeOfFund';
export const ModuleBankInfoCategory = 'bankInfoCategory';
export const ModuleBudgetGroupItem = 'budgetGroupItem';
export const ModuleBudgetSourceProperty = 'budgetSourceProperty';
export const ModuleCAReceipt = 'cAReceipt';
export const ModulePAGLPayrollExpense = 'pAGLPayrollExpense';
export const ModuleCAReceiptSale = 'cAReceiptSale';
export const ModuleCAReceiptFixedAsset = 'cAReceiptFixedAsset';
export const ModuleCAReceiptSaleUnitCapitalList = 'cAReceiptSaleUnitCapitalList';
export const ModuleBudgetSource = 'budgetSource';
export const ModuleBUVoucherList = 'bUVoucherList';
export const ModuleBudgetItem = 'budgetItem';
export const ModuleBudgetItemCustom = 'budgetItemCustom';
export const ModuleBankInfo = 'bankInfo';
export const ModuleBUPlanAdjustment = 'bUPlanAdjustment';
export const ModuleBudgetKindItem = 'budgetKindItem';
export const ModuleSUTransfer = 'sUTransfer';
export const ModuleApproveSUTransfer = 'approveSUTransfer';
export const ModuleInInwardOutward = 'inInwardOutward';
export const ModuleInOutward = 'inOutward';
export const ModuleReArrangeInventory = 'reArrangeInventory';
export const ModuleSUIncrementDecrement = 'sUIncrementDecrement';

export const ModuleBUPlanWDAdjustment = 'bUPlanWDAdjustment';
export const ModulePUInvoice = 'pUInvoice';
export const ModulePUPayment = 'pUPayment';
export const ModuleINTransfer = 'iNTransfer';
export const ModuleINAdjustment = 'iNAdjustment';
export const ModulePurchasePurpose = 'purchasePurpose';
export const ModuleCAPayment = 'cAPayment';
export const ModuleCAPaymentDetail = 'cAPaymentDetail';
export const ModuleCAPaymentDetailTax = 'cAPaymentDetail';
export const ModuleCAFundInventory = 'cAFundInventory';
export const ModuleBudgetFees = 'budgetFees';
export const ModuleAccountTransfer = 'accountTransfer';
export const ModuleBADeposit = 'bADeposit';
export const ModuleAutoBusiness = 'autoBusiness';
export const ModuleSAInvoice = 'sAInvoice';
export const ModuleBABankTransfer = 'bABankTransfer';
export const ModuleBUBudgetReserve = 'bUBudgetReserve';
export const ModuleApproveVoucherBUBudgetReserveTab = 'approveVoucherBUBudgetReserveTab';
export const ModuleGLVoucher = 'gLVoucher';
export const ModuleGLVoucherList = 'gLVoucherList';
export const ModuleApproveVoucherGLBeginningYearTransferTab = 'approveVoucherGLBeginningYearTransferTab';
export const ModuleActivity = 'activity';
export const ModuleCustomerVendor = 'customerVendor';
export const ModuleAccountingObjectCategory = 'accountingObjectCategory';
export const ModuleVoucherType = 'voucherType';
export const ModuleSAReturn = 'sAReturn';
export const ModuleInvoiceFormNumber = 'invoiceFormNumber';
export const ModuleBUCommitmentRequest = 'bUCommitmentRequest';
export const ModuleBUCommitmentAdjustment = 'bUCommitmentAdjustment';
export const ModuleBUOpeningCommitment = 'bUOpeningCommitment';
export const ModuleProject = 'project';
export const ModuleTargetProgram = 'targetProgram';
export const ModuleProjectBudgetDetail = 'projectBudgetDetail';
export const ModuleContract = 'contract';
export const ModuleTask = 'task';
export const ModuleTopic = 'topic';
export const ModuleTopicCustom = 'topicCustom';
export const ModuleTopicEstimate = 'topicEstimate';
export const ModuleWorkItem = 'workItem';
export const ModuleQltsVoucher = 'qltsVoucher';
export const ModuleBATransfer = 'bATransfer';
export const ModuleBUPlanImport = 'bUPlanImport';
export const ModuleCRERepList = 'cRERepList';
export const ModuleAccountParallelRule = 'accountParallelRule';
export const ModuleDefaultAccount = 'defaultAccount';
export const ModuleDefaultAccountCache = 'defaultAccountCache';

export const ModuleCRERepExportList = 'cRERepExportList';
export const moduleCRERepExportXML = 'cRERepExportXML';
export const ModuleCRERepExportTaxList = 'cRERepExportTaxList';
export const ModuleCREREPForSuperiorPopup = 'cREREPForSuperiorPopup';
export const ModuleOpeningSupplyEntry = 'openingSupplyEntry';
export const ModuleFundStructure = 'fundStructure';
export const ModuleCRERepSettlement = 'cRERepSettlement';
export const ModuleDbOption = 'dbOption';
export const ModuleOpeningAccountEntry = 'openingAccountEntry';
export const ModuleOpeningBankAccountEntry = 'openingBankAccountEntry';
export const ModuleOpeningCustomerAccountEntry = 'openingCustomerAccountEntry';
export const ModuleOpeningSupplierAccountEntry = 'openingSupplierAccountEntry';
export const ModuleOpeningEmployeeAccountEntry = 'openingEmployeeAccountEntry';
export const ModuleOpeningInventoryEntry = 'openingInventoryEntry';
export const ModuleSalaryScale = 'salaryScale';
export const ModulePAOption = 'pAOption';
export const ModulePayrollItemColumn = 'payrollItemColumn';
export const ModuleOpeningAccountEntryStatistic = 'openingAccountEntryStatistic';

export const ModuleBudgetProvide = 'budgetProvide';
export const ModuleAccountParallelRuleDetail = 'accountParallelRuleDetail';
export const ModuleBudgetSourceTranfer = 'budgetSourceTranfer';
export const ModuleAccountingObjectChangeRate = 'accountingObjectChangeRate';

export const ModuleToolType = 'toolType';
export const ModuleAccountChangeTranfer = 'accountChangeTranfer';
export const ModuleBudgetKindItemTranfer = 'budgetKindItemTranfer';
export const ModuleStateBank = 'stateBank';
export const ModuleCommercialBank = 'commercialBank';
export const ModuleProjectTranfer = 'projectTranfer';
export const ModulePUVendorPayment = 'pUVendorPayment';
export const ModuleSysAccountParallelVoucherListRule = 'sysAccountParallelVoucherListRule';
export const ModuleSysAccountParallelVoucherListRuleDetail = 'sysAccountParallelVoucherListRuleDetail';

//module chứng từ 05TT
export const ModuleVoucher05TT = 'voucher05TT';

export const ModuleSASaleInvoice = 'sASaleInvoice';
export const ModuleSalary = 'pASalary';
export const ModuleLayoutTemplate = 'pALayoutTemplate';
export const ModulePAPersonalIncomeTax = 'pAPersonalIncomeTax';

export const ModuleOtherInputSalary = 'pAOtherInputSalary'; // vqphong - 17.10.2022

/**begin Các module của chức năng Duyệt chứng từ */
export const ModuleApproveVoucherCAReceiptPlanWithdrawList = 'approveVoucherCAReceiptPlanWithdrawList';

export const ModuleApproveVoucherBUPlanReceipt = 'approveVoucherBUPlanReceipt';

export const ModuleApproveVoucherCAReceiptList = 'approveVoucherCAReceiptList';

export const ModuleApproveVoucherBUPlanCancelTab = 'approveVoucherBUPlanCancelTab';
export const ModuleApproveVoucherBABankTransferTab = 'approveVoucherBABankTransferTab';
export const ModuleApproveVoucherSAReturnList = 'approveVoucherSAReturnList';

export const ModuleApproveVoucherBAWithDrawTab = 'approveVoucherBAWithDrawTab';

export const ModuleApproveVoucherBUOpeningCommitmentTab = 'approveVoucherBUOpeningCommitmentTab';
export const ModuleApproveVoucherBUCommitmentRequestTab = 'approveVoucherBUCommitmentRequestTab';
export const ModuleApproveVoucherBUPlanAdjustmentTab = 'approveVoucherBUPlanAdjustmentTab';

export const ModuleApproveVoucherBUTransferTab = 'approveVoucherBUTransferTab';
export const ModuleApproveVoucherPUPaymentTab = 'approveVoucherPUPaymentTab';
export const ModuleApproveVoucherFAPurchaseIncrementList = 'approveVoucherFAPurchaseIncrementList';
export const ModuleApproveVoucherCAPayment = 'approveVoucherCAPayment';
export const ModuleApproveVoucherBADepositTab = 'approveVoucherBADepositTab';
export const ModuleApproveVoucherBUPlanWithdrawTab = 'approveVoucherBUPlanWithdrawTab';
export const ModuleApproveVoucherCAReceiptCustomer = 'approveVoucherCAReceiptCustomer';
export const ModuleApproveVoucherBUCommitmentAdjustmentTab = 'approveVoucherBUCommitmentAdjustmentTab';
export const ModuleApproveVoucherINTransferList = 'approveVoucherINTransferList';
export const ModuleApproveVoucherSAInvoiceTab = 'approveVoucherSAInvoiceTab';
export const ModuleApproveVoucherINInwardTab = 'approveVoucherINInwardTab';
export const ModuleApproveVoucherINOutward = 'approveVoucherInInwardOutward';
export const ModuleApproveVoucherPUInvoiceList = 'approveVoucherPUInvoiceList';
export const ModuleApproveVoucherPUVendorPaymentTab = 'approveVoucherPUVendorPaymentTab';
export const ModuleApproveVoucherBUPlanWDAdjustmentTab = 'approveVoucherBUPlanWDAdjustmentTab';
export const ModuleApproveVoucherSASaleInvoiceTab = 'approveVoucherSASaleInvoiceTab';
export const ModuleApproveVoucherReceiptList = 'approveVoucherReceiptList';
export const ModuleApproveElectronicTicketList = 'approveElectronicTicketList';
export const ModuleApproveVoucherQltsVoucher = 'approveVoucherQltsVoucher';
export const ModuleApproveVoucherGLEndYearTransferTab = 'approveVoucherGLEndYearTransferTab';
export const ModuleApproveVoucherFATransferList = 'approveVoucherFATransferList';
/**end Các module của chức năng Duyệt chứng từ */
export const ModuleApproveVoucherINAdjustmentList = 'approveVoucherINAdjustmentList';
export const ModuleApproveVoucherGLVoucherTab = 'approveVoucherGLVoucherTab';
export const ModuleApproveBATransferTab = 'approveVoucherBATransferTab';

export const ModuleWebSocketGlobal = 'webSocketGlobal';

export const ModuleMappingBudgetSourceFixedAsset = 'mappingBudgetSourceFixedAsset';
export const ModuleApproveVoucherGLProfitLossTransferVoucher = 'approveVoucherGLProfitLossTransferVoucher';
export const ModuleGLProfitLossTransferVoucher = 'gLProfitLossTransferVoucher';

export const ModuleChoseFinanceReportSetting = 'choseFinanceReportSetting';
export const ModuleFrTemplateCustom = 'frTemplateCustom';

export const ModuleFormulaCustom = 'formulaCustom';
export const ModuleColumnList = 'columnList';

export const ModuleSASaleInvoiceReference = 'sASaleInvoiceReference';
export const ModuleSASaleInvoiceStatus = 'sASaleInvoiceStatus';
export const ModuleSASaleInvoiceCancel = 'sASaleInvoiceCancel';
export const ModuleDVCFile = 'dVCFile';

export const ModuleDVCFileDetail = 'dVCFileDetail';
export const ModuleNotification = 'notification';

export const ModuleQlthEmis = 'qlthEmisVoucher';

export const ModuleVoucherSearch = 'voucherSearch';
export const ModuleDVCFileC202 = 'dVCFileC202';
export const ModuleDVCFileC203 = 'dVCFileC203';
export const ModuleDVCFileC205 = 'dVCFileC205';
export const ModuleDVCFileC402 = 'dVCFileC402';
export const ModuleDVCFileM01 = 'dVCFileM01';
export const ModuleDVCFileM04a = 'dVCFileM04a';
export const ModuleDVCFileM04b = 'dVCFileM04b';
export const ModulePAStatisticalDayOff = 'pAStatisticalDayOff';
export const ModulePASortEmployee = 'pASortEmployee';
export const ModulePAEmployeeHistory = 'pAEmployeeHistory';

export const ModulePAOtherInputSalary = 'pAOtherInputSalary';

export const ModuleDiCacheConfig = 'diCacheConfig';
export const ModuleAccountCombo = 'accountCombo';
export const ModuleAutoBusinessCache = 'autoBusinessCache';
export const ModuleStaticReportPrint = 'staticReportPrint';
export const ModuleConvertDataCompare = 'convertDataCompare';

export const ModuleSYSAuditingLog = 'sYSAuditingLog';

export const ModuleConvertData = 'convertData';
export const ModuleApproveGLPayrollExpenseTab = 'approveGLPayrollExpenseTab';

export const ModuleSysUser = 'sysUser';
export const ModuleConfirmSysUser = 'confirmSysUser';
// phân quyền
export const ModuleSysRole = 'sysRole';
// Đánh giá lại TSCĐ khi chưa kết nối QLTS
export const ModuleFAAdjustment = 'fAAdjustment';
export const ModuleFAIncrementDecrement = 'fAIncrementDecrement';
export const ModuleFADecrement = 'fADecrement';
export const ModuleFAPurchaseIncrement = 'fAPurchaseIncrement';
// Nhận bằng hiện vật và ghi tăng chưa kết nối Qlts
export const ModuleApproveVoucherFAIncrementList = 'approveVoucherFAIncrementList';
export const ModuleApproveVoucherFADecrementList = 'approveVoucherFADecrementList';
export const ModuleFAIncrement = 'fAIncrement';
export const ModuleFADevaluation = 'fADevaluation';
export const ModuleApproveVoucherFADevaluationList = 'approveVoucherFADevaluationList';

export const ModuleFixedAssetCategory = 'fixedAssetCategory';
export const ModuleFixedAssetCategoryCustom = 'fixedAssetCategoryCustom';
export const ModuleApproveSUIncrement = 'approveVoucherSUIncrement';
//Form duyệt đánh giá lại tài sản
export const ModuleApproveVoucherFAAdjustmentList = 'approveVoucherFAAdjustmentList';
//Module danh mục tài sản cố định cache
export const ModuleFixedAssetCache = 'fixedAssetCache';
export const ModuleFATransfer = 'fATransfer';

// Đối chiếu số dư KBDT
export const ModuleDCSDFile = 'dCSDFile';

// Đối chiếu số dư KBDT chi tiết
export const ModuleDCSDFileDetail = 'dCSDFileDetail';
// Hao mòn TSCĐ
export const ModuleFADepreciation = 'fADepreciation';

export const ModuleAuditingReconcileBalance = 'auditingReconcileBalance';

// thuế
export const ModuleTACircularVATDeclaration = 'tACircularVATDeclaration'; // tờ khai giá trị gia tăng
export const ModuleTACircularVATDeclarationDirect = 'tACircularVATDeclarationDirect'; // tờ khai giá trị gia tăng
export const ModuleTARiskCustomerVendor = 'taRiskCustomerVendor'; // danh sách kh,ncc rủi ro
export const ModuleOrganizationHaveRisk = 'organizationHaveRisk'; // tờ khai giá trị gia tăng
export const ModuleTAEnterpriseIncomeTax = 'tAEnterpriseIncomeTax'; // tờ khai thuế thu nhập doanh nghiệp
// Doanh thu bán TSCĐ
export const ModuleApproveVoucherCAReceiptFixedAsset = 'approveVoucherCAReceiptFixedAsset'; // tờ khai giá trị gia tăng
export const ModuleTAVATDeclarationAppendix = 'tAVATDeclarationAppendix';
export const ModuleB58KTNN = 'bUB58KTNN';
export const ModuleBackupDatabase = 'backupDatabase';

export const ModuleHelpSettlement = 'HelpSettlement';
export const ModuleUpDownFixedAsset = 'UpDownFixedAsset';

export const ModuleRestoreVoucher = 'restoreVoucher'; // Phục hồi chứng từ đã xóa

// Báo cáo mẫu merge
export const ModuleRPMergeReport = 'rpMergeReport';
/**
 * Module chọn chứng từ tùy chọn in
 */
export const ModuleChooseVoucherReportFADepreciation = 'chooseVoucherReportFADepreciation';
export const ModuleChooseVoucherReportGLVoucherSummaryTable = 'chooseVoucherReportGLVoucherSummaryTable';
/**
 * Danh sách module của chương trình
 */
// Nộp báo cáo lên cấp trên
export const ModuleCRERepReportSubmit = 'cRERepReportSubmit';

export const ModuleSAReceipt = 'sAReceipt';
export const ModuleSAElectronicTicket = 'sAElectronicTicket';
export const ModuleCollectionAgency = 'collectionAgency';
export const ModuleTempFixedAssetCategory = 'tempFixedAssetCategory';
export const ModuleSurplusDeficit = 'moduleSurplusDeficit';
export const ModuleResultActivity = 'moduleResultActivity';
export const ModuleBudgetSituation = 'moduleBudgetSituation';
export const ModulePayableDebt = 'modulePayableDebt';
export const ModuleUsingSaving = 'moduleUsingSaving';
export const ModuleUsingIncomeAndExpense = 'moduleUsingIncomeAndExpense';
export const ModuleReceivableDebt = 'moduleReceivableDebt';
export const ModuleBudgetPlanImplementation = 'moduleBudgetPlanImplementation';
export const ModuleCashBalanceDeposit = 'moduleCashBalanceDeposit';

export const ModuleOrganizationShareFormula = 'moduleOrganizationShareFormula';

export const ModuleChoseLayoutReportSetting = 'moduleChoseLayoutReportSetting';

// Module phục vụ cho làm việc offline
export const ModuleOfflineWork = 'moduleOfflineWork';
export const ModuleOfflineVoucher = 'moduleOfflineVoucher';
export const ModuleOriginalLedger = 'lgLedgerOriginal';

// invoiceBot
export const ModuleInvoiceBot = 'moduleInvoiceBot';
export const ModuleDictionaryOption = 'dictionaryOption';

export const AppModules = [
  ModuleAccountCombo,
  ModuleAutoBusinessCache,
  ModuleDiCacheConfig,
  ModuleContext,
  ModuleOption,
  ModuleEmployee,
  ModuleEmployeeType,
  ModuleFixedAsset,
  ModulePayrollItem,
  ModuleLayout,
  ModuleOrganizationUnit,
  ModuleAsset,
  ModuleInventoryItem,
  ModuleToolList,
  ModuleAccount,
  ModuleBuPlanWithDraw,
  ModuleBUTransfer,
  ModuleApproveSUTransfer,
  ModuleAccountingObject,
  ModuleAccountingObjectCache,
  ModuleDepartment,
  ModuleCurrency,
  ModuleBaWithdraw,
  ModuleInventoryCategory,
  ModuleStock,
  ModuleBuPlanReceipt,
  ModuleBudgetChapter,
  ModuleStatistic,
  ModuleTypeOfFundObject,
  ModuleBankInfoCategory,
  ModuleBudgetGroupItem,
  ModuleBudgetSourceProperty,
  ModuleCAReceipt,
  ModuleCAReceiptSale,
  ModuleCAReceiptFixedAsset,
  ModuleBudgetSource,
  ModuleBankInfo,
  ModuleBUVoucherList,
  ModuleBudgetItem,
  ModuleBudgetItemCustom,
  ModuleBUPlanAdjustment,
  ModuleBudgetKindItem,
  ModuleSUTransfer,
  ModuleInInwardOutward,
  ModuleInOutward,
  ModuleReArrangeInventory,
  ModuleSUIncrementDecrement,
  ModuleBUPlanWDAdjustment,
  ModulePUInvoice,
  ModulePUPayment,
  ModuleINTransfer,
  ModuleINAdjustment,
  ModulePurchasePurpose,
  ModuleCAPayment,
  ModuleCAPaymentDetail,
  ModuleCAPaymentDetailTax,
  ModuleCAFundInventory,
  ModuleBudgetFees,
  ModuleAccountTransfer,
  ModuleBADeposit,
  ModuleAutoBusiness,
  ModuleSAInvoice,
  ModuleBABankTransfer,
  ModuleBUBudgetReserve,
  ModuleApproveVoucherBUBudgetReserveTab,
  ModuleGLVoucher,
  ModuleGLVoucherList,
  ModuleApproveVoucherGLBeginningYearTransferTab,
  ModuleActivity,
  ModuleCustomerVendor,
  ModuleAccountingObjectCategory,
  ModuleVoucherType,
  ModuleSAReturn,
  ModuleInvoiceFormNumber,
  ModuleBUCommitmentRequest,
  ModuleBUCommitmentAdjustment,
  ModuleBUOpeningCommitment,
  ModuleProject,
  ModuleTargetProgram,
  ModuleProjectBudgetDetail,
  ModuleContract,
  ModuleTask,
  ModuleTopic,
  ModuleTopicCustom,
  ModuleTopicEstimate,
  ModuleWorkItem,
  ModuleQltsVoucher,
  ModuleBATransfer,
  ModuleBUPlanImport,
  ModuleCRERepList,
  ModuleOpeningSupplyEntry,
  ModuleFundStructure,
  ModuleAccountParallelRule,
  ModuleCRERepExportList,
  moduleCRERepExportXML,
  ModuleDefaultAccount,
  ModuleDefaultAccountCache,
  ModuleCRERepSettlement,
  ModuleDbOption,
  ModuleCRERepExportTaxList,
  ModuleCREREPForSuperiorPopup,
  ModuleOpeningAccountEntry,
  ModuleOpeningBankAccountEntry,
  ModuleOpeningCustomerAccountEntry,
  ModuleOpeningSupplierAccountEntry,
  ModuleOpeningEmployeeAccountEntry,
  ModuleOpeningInventoryEntry,
  ModuleSalaryScale,
  ModulePAOption,
  ModulePayrollItemColumn,
  ModuleOpeningAccountEntryStatistic,
  ModuleBudgetProvide,
  ModuleAccountParallelRuleDetail,
  ModuleBudgetSourceTranfer,
  ModuleToolType,
  ModuleBudgetProvide,
  ModuleAccountingObjectChangeRate,
  ModuleAccountChangeTranfer,
  ModuleBudgetKindItemTranfer,
  ModuleStateBank,
  ModuleCommercialBank,
  ModuleProjectTranfer,
  ModuleSysAccountParallelVoucherListRule,
  ModuleSysAccountParallelVoucherListRuleDetail,
  ModulePUVendorPayment,
  ModuleVoucher05TT,
  ModuleSASaleInvoice,

  ModuleApproveVoucherCAReceiptPlanWithdrawList,
  ModuleApproveVoucherBUPlanReceipt,
  ModuleApproveVoucherBUPlanCancelTab,
  ModuleApproveVoucherBABankTransferTab,
  ModuleApproveVoucherSAReturnList,
  ModuleApproveVoucherCAReceiptList,
  ModuleApproveVoucherBUTransferTab,
  ModuleApproveVoucherPUPaymentTab,
  ModuleApproveVoucherFAPurchaseIncrementList,
  ModuleApproveVoucherBUPlanWithdrawTab,
  ModuleApproveVoucherCAPayment,
  ModuleApproveVoucherBUCommitmentAdjustmentTab,
  ModuleApproveVoucherBAWithDrawTab,
  ModuleApproveVoucherBADepositTab,
  ModuleApproveVoucherBUOpeningCommitmentTab,
  ModuleApproveVoucherBUCommitmentRequestTab,
  ModuleApproveVoucherSAInvoiceTab,
  ModuleApproveVoucherCAReceiptCustomer,
  ModuleApproveVoucherINInwardTab,
  ModuleApproveVoucherPUInvoiceList,
  ModuleApproveVoucherINAdjustmentList,
  ModuleApproveVoucherINTransferList,
  ModuleApproveVoucherPUVendorPaymentTab,
  ModuleApproveVoucherINOutward,
  ModuleApproveVoucherBUPlanAdjustmentTab,
  ModuleApproveVoucherBUPlanWDAdjustmentTab,
  ModuleApproveVoucherSASaleInvoiceTab,
  ModuleApproveVoucherReceiptList,
  ModuleApproveElectronicTicketList,
  ModuleSASaleInvoice,
  ModuleApproveVoucherQltsVoucher,
  ModuleApproveVoucherGLEndYearTransferTab,
  ModuleApproveVoucherFATransferList,

  ModuleMappingBudgetSourceFixedAsset,
  ModuleApproveVoucherGLVoucherTab,
  ModuleApproveBATransferTab,
  ModuleGLProfitLossTransferVoucher,
  ModuleApproveVoucherGLProfitLossTransferVoucher,
  ModuleChoseFinanceReportSetting,
  ModuleFrTemplateCustom,
  ModuleFormulaCustom,
  ModuleColumnList,
  ModuleSASaleInvoiceReference,
  ModuleSASaleInvoiceStatus,
  ModuleSASaleInvoiceCancel,
  ModuleDVCFile,
  ModuleDVCFileDetail,
  ModuleNotification,
  ModuleQlthEmis,
  ModuleVoucherSearch,
  ModulePAEmployeeHistory,
  ModulePAStatisticalDayOff,
  ModulePASortEmployee,
  ModuleDVCFileC202,
  ModuleDVCFileC203,
  ModuleDVCFileC205,
  ModuleDVCFileC402,
  ModuleDVCFileM01,
  ModuleDVCFileM04a,
  ModuleDVCFileM04b,
  ModulePAOtherInputSalary,
  ModulePAGLPayrollExpense,
  ModuleStaticReportPrint,

  ModuleSYSAuditingLog,
  ModuleConvertDataCompare,
  ModuleSysUser,
  ModuleConfirmSysUser,
  ModuleConvertData,
  ModuleApproveGLPayrollExpenseTab,
  ModuleSysRole,
  ModuleFAAdjustment,
  ModuleFAIncrementDecrement,
  ModuleFADecrement,
  ModuleFAPurchaseIncrement,
  ModuleFixedAssetCategory,
  ModuleFixedAssetCategoryCustom,
  ModuleFADevaluation,
  ModuleApproveVoucherFADevaluationList,

  ModuleApproveSUIncrement,
  ModuleDCSDFile,
  ModuleDCSDFileDetail,
  ModuleApproveVoucherFAIncrementList,
  ModuleApproveVoucherFADecrementList,
  ModuleFAIncrement,
  ModuleFADepreciation,
  ModuleFATransfer,
  ModuleAuditingReconcileBalance,

  ModuleTACircularVATDeclaration,
  ModuleTACircularVATDeclarationDirect,
  ModuleTAVATDeclarationAppendix,
  ModuleTARiskCustomerVendor,
  ModuleOrganizationHaveRisk,
  ModuleTAEnterpriseIncomeTax,
  ModuleApproveVoucherCAReceiptFixedAsset,
  ModuleB58KTNN,
  ModuleBackupDatabase,
  ModuleHelpSettlement,
  ModuleUpDownFixedAsset,
  ModuleRPMergeReport,
  ModuleSalary,
  ModuleLayoutTemplate,
  ModuleChooseVoucherReportFADepreciation,
  ModuleChooseVoucherReportGLVoucherSummaryTable,
  ModuleRestoreVoucher,
  ModuleCRERepReportSubmit,
  ModuleSAReceipt,
  ModuleSAElectronicTicket,
  ModuleCollectionAgency,
  ModuleTempFixedAssetCategory,
  ModuleOrganizationShareFormula,
  ModuleChoseLayoutReportSetting,
  ModuleOfflineWork,
  ModuleOfflineVoucher,

  ModuleInvoiceBot,
  ModuleOriginalLedger,
  ModuleDictionaryOption,
];
